'use strict';

wbApp.controller('DashboardCtrl', ['$scope',
function ($scope) {
}]);